module.exports = {"id":"163713","name":"Christophe Mandanne","rating":"72","photo":"./data/images/photos/0/163713.png","club":{"name":"LB Châteauroux","logo":"./data/images/clubs/LBChateauroux.png"},"positions":["BU","ATT"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ChristopheMandanne0.json
// module id = 811
// module chunks = 0